module.exports = __webpack_public_path__ + "img/vertical_6_7_3009.739410c8.png";